<template>
    <DesignExamplesLayout>
        <header class="DesignExamplesColors__header">
            <h1 class="DesignExamplesColors__title">
                Colors
            </h1>
            <p class="DesignExamplesColors__subtitle">
                Color palette and CSS variables
            </p>
        </header>
        <ColorsExample />
    </DesignExamplesLayout>
</template>

<style lang="scss" scoped>
.DesignExamplesColors {
    &__header {
        margin-bottom: 2rem;
    }

    &__title {
        margin: 0 0 0.25rem;
        font-size: 1.5rem;
        font-weight: 600;
        color: var(--eidTechGray);
    }

    &__subtitle {
        margin: 0;
        font-size: 0.875rem;
        color: var(--eidTechGray-75);
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import ColorsExample from '@/modules/design-examples/components/ColorsExample.vue';

    import DesignExamplesLayout from './DesignExamplesLayout.vue';

    export default defineComponent({
        name: 'DesignExamplesColors',
        components: { DesignExamplesLayout, ColorsExample },
    });
</script>
